/**
 * Shared GraphQL mutations for the SocialHood app
 * Centralized to avoid duplication and maintain consistency
 */

export const POST_MUTATIONS = {
  CREATE_POST: `
    mutation CreatePost($input: CreatePostInput!) {
      createPost(input: $input) {
        id
        title
        content
        author
        authorId
        authorProfilePic
        neighborhood
        owner
        upvoteCount
        downvoteCount
        createdAt
        updatedAt
      }
    }
  `,

  UPDATE_POST: `
    mutation UpdatePost($input: UpdatePostInput!) {
      updatePost(input: $input) {
        id
        title
        content
        author
        authorId
        authorProfilePic
        neighborhood
        owner
        createdAt
        updatedAt
      }
    }
  `,

  DELETE_POST: `
    mutation DeletePost($input: DeletePostInput!) {
      deletePost(input: $input) {
        id
      }
    }
  `
};

export const VOTE_MUTATIONS = {
  CREATE_VOTE: `
    mutation CreateVote($input: CreateVoteInput!) {
      createVote(input: $input) {
        id
        postId
        userId
        voteType
        owner
        createdAt
        updatedAt
      }
    }
  `,

  UPDATE_VOTE: `
    mutation UpdateVote($input: UpdateVoteInput!) {
      updateVote(input: $input) {
        id
        postId
        userId
        voteType
        owner
        createdAt
        updatedAt
      }
    }
  `,

  DELETE_VOTE: `
    mutation DeleteVote($input: DeleteVoteInput!) {
      deleteVote(input: $input) {
        id
      }
    }
  `,

  INCREMENT_UPVOTE: `
    mutation IncrementUpvote($postId: ID!) {
      incrementUpvote(postId: $postId) {
        id
        upvoteCount
        downvoteCount
        updatedAt
      }
    }
  `,

  DECREMENT_UPVOTE: `
    mutation DecrementUpvote($postId: ID!) {
      decrementUpvote(postId: $postId) {
        id
        upvoteCount
        downvoteCount
        updatedAt
      }
    }
  `,

  INCREMENT_DOWNVOTE: `
    mutation IncrementDownvote($postId: ID!) {
      incrementDownvote(postId: $postId) {
        id
        upvoteCount
        downvoteCount
        updatedAt
      }
    }
  `,

  DECREMENT_DOWNVOTE: `
    mutation DecrementDownvote($postId: ID!) {
      decrementDownvote(postId: $postId) {
        id
        upvoteCount
        downvoteCount
        updatedAt
      }
    }
  `
};

export const COMMENT_MUTATIONS = {
  CREATE_COMMENT: `
    mutation CreateComment($input: CreateCommentInput!) {
      createComment(input: $input) {
        id
        postId
        content
        author
        authorId
        authorProfilePic
        createdAt
        updatedAt
      }
    }
  `,

  UPDATE_COMMENT: `
    mutation UpdateComment($input: UpdateCommentInput!) {
      updateComment(input: $input) {
        id
        postId
        content
        author
        authorId
        authorProfilePic
        createdAt
        updatedAt
      }
    }
  `,

  DELETE_COMMENT: `
    mutation DeleteComment($input: DeleteCommentInput!) {
      deleteComment(input: $input) {
        id
      }
    }
  `
};

export const IMAGE_MUTATIONS = {
  CREATE_POST_IMAGE: `
    mutation CreatePostImage($input: CreatePostImageInput!) {
      createPostImage(input: $input) {
        id
        postId
        originalUrl
        mediumUrl
        thumbnailUrl
        fileName
        fileSize
        mimeType
        width
        height
        uploadedBy
        order
        createdAt
        updatedAt
      }
    }
  `,

  DELETE_POST_IMAGE: `
    mutation DeletePostImage($input: DeletePostImageInput!) {
      deletePostImage(input: $input) {
        id
      }
    }
  `
};

export const REPORT_MUTATIONS = {
  CREATE_REPORT: `
    mutation CreateReport($input: CreateReportInput!) {
      createReport(input: $input) {
        id
        postId
        reporterId
        reporterName
        reason
        description
        status
        createdAt
        updatedAt
      }
    }
  `
};